<template>
  <div
    v-if="index < 3"
    class="rounded-b-full absolute right-10 top-0 flex w-[42px] flex-col items-center justify-center gap-4 px-8 pb-12 pt-8"
    :class="{
      'bg-static-info-max': index === 0,
      'bg-static-default-hi': index === 1,
      'bg-static-warning-mid': index === 2,
    }"
  >
    <RevIllustration
      alt=""
      :height="11"
      role="presentation"
      src="/img/product/jp/crown.svg"
      :width="12"
    />

    <div class="flex items-baseline justify-center">
      <span class="heading-2">{{ index + 1 }}</span>
      <span
        class="caption-bold [text-orientation:upright] [writing-mode:vertical-rl]"
      >
        {{ i18n(translations.rank) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './RankingTag.translations'

const { index } = defineProps<{
  index: number
}>()

const i18n = useI18n()
</script>
